<template>
  <div class="search-picker">
    <v-date-picker v-if="start && end"
                   v-model="range"
                   :color="'orange'"
                   :columns="$screens({ lg: 2 }, 1)"
                   :locale="lang"
                   :min-date="minDateStart"
                   :mode="'range'"
                   is-range>
      <template>
        <div :class="{errored: errored}" class="input-placeholder">
          <div class="input-icon">
            <img alt="" src="/static/img/calendar-day-light.svg">
          </div>
          <span class="value">{{ displayText }}</span>
        </div>
      </template>
    </v-date-picker>
    <div v-else class="input-placeholder">
      <div class="input-icon">
        <img alt="" src="/static/img/calendar-day-light.svg">
      </div>
      <span class="value">{{ $t('v2.date-picker.placeholder') }}</span>
    </div>
  </div>
</template>

<script>
import * as moment from 'moment';
import {mapState} from "vuex";
import {CAN_BOOK_DAY_USE} from "../../../common";

export default {
  name: "search-dates",
  computed: {
    // Cette propriété calculée agit comme une passerelle avec le store Vuex.
    // Elle lit la valeur (get) et la met à jour (set) de manière sûre.
    range: {
      get() {
        return {
          start: this.start,
          end: this.end
        };
      },
      set(v) {
        this.$store.commit('search/SET_SEARCH_START_DATE', v.start);
        this.$store.commit('search/SET_SEARCH_END_DATE', v.end);
      }
    },
    displayText() {
      // ✅ Correction : la propriété 'range' est maintenant garantie d'être un objet avec 'start' et 'end'
      // Grâce à la liaison ci-dessus et à l'initialisation du store.
      if (!this.range.start || !this.range.end) {
        return this.$t('v2.date-picker.placeholder');
      }
      const start = moment(this.range.start).format(this.$t('v2.date-picker.format'));
      const end = moment(this.range.end).format(this.$t('v2.date-picker.format'));
      return this.$t('v2.date-picker.label', start, end);
    },

    errored() {
      // ✅ Correction : la propriété 'range' est maintenant garantie d'être un objet avec 'start' et 'end'
      if (!this.range.start || !this.range.end) {
        return true;
      }
      const dayDiff = moment(this.range.start).diff(moment(this.range.end), 'd');
      return (dayDiff === 0 && !CAN_BOOK_DAY_USE);
    },
    ...mapState({
      lang: s => s.lang.lang,
      start: s => s.search.search.start,
      end: s => s.search.search.end,
    })
  },
  data() {
    return {
      // On retire la variable 'range' car elle est maintenant gérée par le 'computed'
      minDateStart: moment().toDate(),
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/search/picker/search-dates.vue